import contentful from '@/services/contentful';

export default {
  getProducts() {
    return contentful.fetchContent({
      content_type: 'product',
      include: 10,
    });
  },
  getProductBySlug(slug) {
    return contentful.fetchContent({
      content_type: 'product',
      include: 10,
      'fields.slug[match]': slug,
    });
  },
};
